import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, Selection, IColumn, SelectionMode, Panel, Label, TextField, PanelType, CheckboxVisibility, Link, IGroup, } from '@fluentui/react';
import {  DetailsRow, IDetailsRowStyles, IDetailsListProps } from 'office-ui-fabric-react/lib/DetailsList';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { DataService } from "../Services/DataService";
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { IWetenschappelijkWerk } from '../Interfaces/IWetenschappelijkWerk';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import _ from 'lodash';
const theme = getTheme();
export interface IDisplayWetenschappelijkWerkState {
    items: IWetenschappelijkWerk[];
    itemsService: IWetenschappelijkWerk[];
    selectionDetails: string;
    selectedItem?: IWetenschappelijkWerk;
    showPanel: boolean;
    groups: IGroup[];
}

export class DisplayWetenschappelijkWerk extends React.Component<{}, IDisplayWetenschappelijkWerkState> {
    private _columns: IColumn[];
    private _selection: Selection;

    constructor(props: {}) {
        super(props);

        initializeIcons(/* optional base url */);
        this._selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() }),
        });

        this.state = {
            items: [],
            itemsService: [],
            selectionDetails: this._getSelectionDetails(),
            showPanel: false,
            groups: []
        };

        this._getWetenschappelijkWerkData();

        this._columns = [
            // { key: 'Title', name: 'Title', fieldName: 'Title', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Publicatie', name: 'Publicatie', fieldName: 'Publicatie', minWidth: 100, maxWidth: 400, isResizable: true, 
            onRender: (item: IWetenschappelijkWerk) => {
                return <div className={"content"} dangerouslySetInnerHTML={{ __html: item.Publicatie }} />
              }, },
            // { key: 'PreId', name: 'PreId', fieldName: 'PreId', minWidth: 100, maxWidth: 200, isResizable: true },
        ];
    }

    async _getWetenschappelijkWerkData() {
        var a = await DataService.getWetenschappelijkWerkData();
        var groups = this._CreateGroups(a);
        this.setState({ items: a, itemsService: a, groups: groups });
    }
    private _onRenderRow: IDetailsListProps['onRenderRow'] = props => {
        const customStyles: Partial<IDetailsRowStyles> = {};
        if (props) {
          if (props.itemIndex % 2 === 0) {
            // Every other row renders with a different background color
            customStyles.root = { backgroundColor: '#F5F5F5' };
          }
    
          return <DetailsRow {...props} styles={customStyles} />;
        }
        return null;
      };
    public render(): JSX.Element {
        const { items } = this.state;

        return (
            <div>
                <h1>Wetenschappelijk werk</h1>
                <TextField
                    label="Filter by name:"
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {

                        if (newValue != null) {
                            var lowerValue = newValue.toLowerCase();
                            var filteredItems = this.state.itemsService.filter((i: IWetenschappelijkWerk) =>
                                (i.Title ? i.Title : '').toLowerCase().indexOf(lowerValue) > -1
                                || (i.Publicatie ? i.Publicatie : '').toLowerCase().indexOf(lowerValue) > -1
                                || (i.Publicatietype ? i.Publicatietype : '').toLowerCase().indexOf(lowerValue) > -1);
                            var groups = this._CreateGroups(filteredItems);
                            this.setState({ items: filteredItems, groups: groups });
                        } else {
                            var groups = this._CreateGroups(this.state.itemsService)
                            this.setState({ items: this.state.itemsService, groups: groups });
                        }

                    }}
                    // onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                    //     this.setState({
                    //         items: newValue ? this.state.itemsService.filter((i: { Title: string; }) => i.Title.toLowerCase().indexOf(newValue) > -1) : this.state.itemsService,
                    //     });
                    // }}
                />
                <DetailsList
                    items={items}
                    columns={this._columns}
                    layoutMode={DetailsListLayoutMode.justified}
                    selection={this._selection}
                    selectionPreservedOnEmptyClick={true}
                    selectionMode={SelectionMode.single}
                    checkboxVisibility={CheckboxVisibility.hidden}
                    compact={true}
                    onRenderRow={this._onRenderRow}
                    groups={this.state.groups}
                />
                <Panel
                    headerText={this.state.selectedItem != null ? this.state.selectedItem.Title : ""}
                    isOpen={this.state.showPanel}
                    onDismiss={() => {
                        this.setState({ showPanel: false });
                        this._selection.setAllSelected(false);
                    }}
                    isLightDismiss
                    type={PanelType.large}
                    closeButtonAriaLabel="Close"

                >


                    {this._fieldRender(this.state.selectedItem, "Publicatie", "Publicatie")}
                    {this._fieldRender(this.state.selectedItem, "Publicatietype", "PublicatieType")}
                    {this._fieldRender(this.state.selectedItem, "Jaar", "Jaar")}

                    {this._fieldRender(this.state.selectedItem, "Version", "Versie")}
                    {this._fieldRender(this.state.selectedItem, "Modified", "Gewijzigd op")}

                    {this.state.selectedItem?.Bijlagen != null ? <Label>Bijlagen:</Label> : null}
                    {this.state.selectedItem?.Bijlagen?.split(';').map((bijlage: string) => {
                        if (bijlage != "") {
                            var filename = bijlage.substring(bijlage.lastIndexOf('/') + 1);
                            return (<div>
                                <Link onClick={() => {
                                    fetch(bijlage)
                                        .then(r => r.blob())
                                        .then((blob) => this.showFile(blob,filename))
                                }}
                                >{filename} </Link>
                            </div>
                            );
                        }
                    })}


                </Panel>
            </div>

        );
    }

    
    private showFile(blob:any,filename:string) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([blob], { type: "application/pdf" })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    private _CreateGroups(data: IWetenschappelijkWerk[]): IGroup[] {

        var groups: IGroup[] = [];
        var index: number = 0;
        data.map((item: IWetenschappelijkWerk) => {

            var jaar = item.Jaar;
            if (groups.filter(x => x.name == jaar).length <= 0) {
                var count = data.filter(x => x.Jaar.indexOf(jaar) == 0).length;
                groups.push({ key: jaar, startIndex: index, name: jaar, count: count, isCollapsed: true });
            }




            index++;
        });

        return groups;
    }
    private _fieldRender(item: any, fieldName: string, displayName: string) {
        return (
            <div>
                <Label>{displayName}</Label>
                <div className={"content"} dangerouslySetInnerHTML={{ __html: item != null ? item[fieldName] != null && item[fieldName] != "" ? item[fieldName] : "Geen" : "Geen" }} />
            </div>
        )
    }
    private async _setSelectedItem(selectionItem: IWetenschappelijkWerk) {
        var item = await DataService.getWetenschappelijkWerkById(selectionItem.Id);
        this.setState({ showPanel: true, selectedItem: item });
    }
    private _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();
        switch (selectionCount) {
            case 0:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
            case 1:
                this._setSelectedItem(this._selection.getSelection()[0] as any)
                return "";
            default:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
        }
    }

}
